"use client";

import { CustomSlider } from "@/components/ui/custom-slider";

interface FloorsSectionProps {
	value?: { min: number; max: number };
	onChange: (value: { min: number; max: number }) => void;
}

const minRange = 1;
const maxRange = 10;

export function FloorsSection({ value, onChange }: FloorsSectionProps) {
	const handleValueChange = (newValues: [number, number]) => {
		onChange({ min: newValues[0], max: newValues[1] });
	};

	// Handle undefined value by using default range
	const currentValue = value || { min: 0, max: 0 };

	const sliderValue: [number, number] = [
		currentValue.min === 0 ? minRange : currentValue.min,
		currentValue.max === 0 ? maxRange : currentValue.max,
	];

	const ticks = Array.from({ length: 10 }, (_, i) => i + 1);

	return (
		<div className="space-y-6">
			{/* Custom Range Slider */}
			<div className="space-y-4">
				<div className="relative h-6 flex items-center px-3">
					<CustomSlider
						value={sliderValue}
						onChange={newValues => handleValueChange(newValues as [number, number])}
						min={minRange}
						max={maxRange}
						step={1}
						isRange={true}
						ariaLabel={["Minimum Floors", "Maximum Floors"]}
						rangeClassName="absolute bg-gray-600 rounded-full h-full"
					/>
				</div>

				{/* Tick Marks with selected values in primary color */}
				<div className="relative px-3">
					<div className="flex justify-between items-center" style={{ paddingLeft: "0.5rem" }}>
						{ticks.map(tick => {
							const isSelected = tick === sliderValue[0] || tick === sliderValue[1];
							return (
								<div key={tick} className="flex flex-col items-center gap-1">
									<div className={`w-px h-2 ${isSelected ? "bg-primary-600" : "bg-gray-400"}`} />
									<span className={`text-xs font-semibold ${isSelected ? "text-primary-600" : "text-gray-600"}`}>
										{tick === 10 ? "10+" : tick}
									</span>
								</div>
							);
						})}
					</div>
				</div>
			</div>

			{/* Input Fields */}
			{/* <div className="grid grid-cols-2 gap-4">
				<div>
					<label className="block text-xs text-gray-500 mb-1">Min Floors</label>
					<Input
						type="number"
						min={minRange}
						max={maxRange}
						value={value.min}
						onChange={e => onChange({ ...value, min: Math.min(Number(e.target.value), value.max || maxRange) })}
						className="text-center font-semibold text-gray-700"
					/>
				</div>
				<div>
					<label className="block text-xs text-gray-500 mb-1">Max Floors</label>
					<Input
						type="number"
						min={minRange}
						max={maxRange}
						value={value.max}
						onChange={e => onChange({ ...value, max: Math.max(Number(e.target.value), value.min || minRange) })}
						className="text-center font-semibold text-gray-700"
					/>
				</div>
			</div> */}
		</div>
	);
}
